/* Transform to TREE!!! */
import _ from "lodash";
Array.prototype.toTree = function(parentFieldName = "parent", itemsFieldName = "items") {
    let byId = {};

    let newArr = _.cloneDeep(this);
    let sortedData = [];

    newArr.forEach((item) => {
        byId[item._id] = item;
    });

    newArr.forEach((item) => {
        if (item[parentFieldName]) {
            let groupItem = byId[item[parentFieldName]];
            if (!groupItem) {
            	console.error("Array.prototype.toTree ERROR, parent item not found!");
            	sortedData.push(item);
            	return;
            }
            if (!groupItem[itemsFieldName]) groupItem[itemsFieldName] = [];
            if (groupItem[itemsFieldName].indexOf(item) == -1) {
                groupItem[itemsFieldName].push(item);
            }
        }
    });

    newArr.forEach((item) => {
        if (!item[parentFieldName]) {
            sortedData.push(item);
        }
    });

    return sortedData;
}